import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import CommonContext from '../../Common';

export const HistoryWatcher = () => {
    const location = useLocation();
    const context = useContext(CommonContext);
    const previousLocationRef = useRef();

    useEffect(() => {
        if (location && location.pathname !== previousLocationRef.current?.pathname) {
            context.setFormOpened(false);
        }

        previousLocationRef.current = location;
    }, [location, context]);

    return null;
};